// extracted by mini-css-extract-plugin
module.exports = {"deliveryStatus":"_1e0_OY","text":"_1Hs7qt","brandColor":"br86Xr","grayColor":"kEae5j","uppercase":"_3nTTG7","truckIcon":"_3TiUS-","shine-lines":"-NIcKd"};